import React from "react";
import "./buffers.scss";

function BizCards({currentLocale}) {
  return (
    <div id="biz-cards-buffer">
      {/* <object data="images/buffers-${currentLocale}/biz-cards/img (1).webp" type="image/webp">
        <img src="images/buffers-${currentLocale}/biz-cards/img (1).png" alt="" />
      </object> */}
      <div className="group">
        <div>
          <img src={`images/buffers-${currentLocale}/biz-cards/img (1).png`} alt="" />
        </div>
        <div>
          <img src={`images/buffers-${currentLocale}/biz-cards/img (2).png`} alt="" />
        </div>
        <div>
          <img src={`images/buffers-${currentLocale}/biz-cards/img (3).png`} alt="" />
        </div>
        <div>
          <img src={`images/buffers-${currentLocale}/biz-cards/img (4).png`} alt="" />
        </div>
        <div>
          <img src={`images/buffers-${currentLocale}/biz-cards/img (5).png`} alt="" />
        </div>
        <div>
          <img src={`images/buffers-${currentLocale}/biz-cards/img (6).png`} alt="" />
        </div>
        <div>
          <img src={`images/buffers-${currentLocale}/biz-cards/img (7).png`} alt="" />
        </div>
      </div>
      <div className="group">
        <div>
          <img src={`images/buffers-${currentLocale}/biz-cards/img (1).png`} alt="" />
        </div>
        <div>
          <img src={`images/buffers-${currentLocale}/biz-cards/img (2).png`} alt="" />
        </div>
        <div>
          <img src={`images/buffers-${currentLocale}/biz-cards/img (3).png`} alt="" />
        </div>
        <div>
          <img src={`images/buffers-${currentLocale}/biz-cards/img (4).png`} alt="" />
        </div>
        <div>
          <img src={`images/buffers-${currentLocale}/biz-cards/img (5).png`} alt="" />
        </div>
        <div>
          <img src={`images/buffers-${currentLocale}/biz-cards/img (6).png`} alt="" />
        </div>
        <div>
          <img src={`images/buffers-${currentLocale}/biz-cards/img (7).png`} alt="" />
        </div>
      </div>
    </div>
  );
}

export default BizCards;
